import UserGroupWithoutCheckboxNodeRenderer from '../../usersAssignedToHierarchy/UserGroupWithoutCheckboxNodeRenderer'
import {USERS_WITHOUT_GROUP_ID} from 'constants'
import UserGroupNodeRenderer from '../../../hierarchySelector/userSelector/UserGroupNodeRenderer'

export default class UserSelectorPanelUserGroupNodeRenderer extends UserGroupWithoutCheckboxNodeRenderer {
    generateContent(treeNode, targetEl) {
        if (treeNode.getValue().id === USERS_WITHOUT_GROUP_ID) {
            super.generateContent(treeNode, targetEl)
        } else {
            UserGroupNodeRenderer.prototype.generateContent.call(this, treeNode, targetEl)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/teamAssignmentsPanel/UserGroupNodeRenderer.js